export enum ECryptoDefaultNetwork {
  ERC20 = "ETH",
  Bitcoin = "BTC",
  BEP20 = "BNB",
  TRC20 = "TRX",
}
